import MapInterface from "../../Interfaces/MapInterface";
import BaseMap from "../BaseMap";
import Virus from "../Virus";
import Fauci from "../Fauci";
import Portal from "../Portal";

export default class LevelOne extends BaseMap implements MapInterface
{
    render(): HTMLElement
    {
        let el = document.createElement('div');
        el.id = 'LevelOne';
        el.classList.add('Level');

        let v1 = new Virus(Math.floor(Math.random() * 40) + 1);
        let v2 = new Virus(Math.floor(Math.random() * 40) + 1);
        let v3 = new Virus(Math.floor(Math.random() * 40) + 1);
        let v4 = new Virus(Math.floor(Math.random() * 40) + 1);

        el.appendChild(v1.render());
        el.appendChild(v2.render());
        el.appendChild(v3.render());
        el.appendChild(v4.render());

        let helper = new Fauci;
        helper.say('Stay safe and stay 6ft away');
        el.appendChild(helper.render());

        setTimeout(() => {
            helper.hide();
        }, 3000);

        let levelTwoPortal = new Portal('LevelTwoPortal');
        let l2El = levelTwoPortal.render()
        this.game.elements.push(l2El);
        levelTwoPortal.setGame(this.game);
        el.appendChild(l2El);

        return el;
    }
}